import { Box, Paper, Typography } from "@mui/material";

const WSU_RED = "#A60F2D";
const rowSx = {
    display: "grid",
    gridTemplateColumns: "45% 1fr",
    borderTop: "1px solid rgba(224, 224, 224, 1)",
};
const labelCellSx = { fontWeight: 600, color: "#444", fontSize: "0.9rem", px: 2, py: 1.5 };
const valueCellSx = { overflowWrap: "anywhere", wordBreak: "break-word", px: 2, py: 1.5 };

export const InfoSection = ({ heading, rows, span = 1 }) => (
    <Paper elevation={2} sx={{ borderRadius: 2, gridColumn: `span ${span}` }}>
        <Box sx={{ px: 3, pt: 3, pb: 1 }}>
            <Typography variant="overline" sx={{ color: WSU_RED, fontWeight: 700, letterSpacing: 1.5 }}>
                {heading}
            </Typography>
        </Box>
        <Box>
            {rows.map(({ key, label, content }) => (
                <Box key={key} sx={rowSx}>
                    <Box sx={labelCellSx}>{label}</Box>
                    <Box sx={valueCellSx}>{content}</Box>
                </Box>
            ))}
        </Box>
    </Paper>
);
